import EsaedroResourceFilter from "./EsaedroResourceFilter";

class EsaedroHistoryItem {
    setSelectedItemFilters(filters: EsaedroResourceFilter[]) {
      throw new Error("Method not implemented.");
    }

    private _selectedItem: any;
    public get selectedItem() : any { return this._selectedItem }   
    public set selectedItem(newvalue: any) { this._selectedItem = newvalue }

    private _itemToEdit: any;
    public get itemToEdit() : any { return this._itemToEdit }   
    public set itemToEdit(newvalue: any) { this._itemToEdit = newvalue }

    private _itemToDel: any;
    public get itemToDel() : any { return this._itemToDel }   
    public set itemToDel(newvalue: any) { this._itemToDel = newvalue }

    private _itemToJump: any;
    public get itemToJump() : any { return this._itemToJump }   
    public set itemToJump(newvalue: any) { this._itemToJump = newvalue }

    private _newItem: boolean = false;
    public get newItem() : boolean { return this._newItem }   
    public set newItem(newvalue: boolean) { this._newItem = newvalue }

    private _menuItems: any[] = [];
    public get menuItems() : any[] { return this._menuItems }   
    public set menuItems(newvalue: any[]) { this._menuItems = newvalue }

    private _jumpMenuItems: any[] = [];
    public get jumpMenuItems() : any[] { return this._jumpMenuItems }   
    public set jumpMenuItems(newvalue: any[]) { this._jumpMenuItems = newvalue }

    private _selectedItemFilters: EsaedroResourceFilter[] = [];
    public get selectedItemFilters() : EsaedroResourceFilter[] { return this._selectedItemFilters }   
    public set selectedItemFilters(newvalue: EsaedroResourceFilter[]) { this._selectedItemFilters = newvalue }

    private _listInputFilters: EsaedroResourceFilter[] = [];
    public get listInputFilters() : EsaedroResourceFilter[] { return this._listInputFilters }   
    public set listInputFilters(newvalue: EsaedroResourceFilter[]) { this._listInputFilters = newvalue }

    private _startingPage: number = 1;
    public get startingPage() : number { return this._startingPage }   
    public set startingPage(newvalue: number) { this._startingPage = newvalue }

    private _customComponentName: string = '';
    public get customComponentName() : string { return this._customComponentName }   
    public set customComponentName(newvalue: string) { this._customComponentName = newvalue }

    /**
     * clearDetailState
     */
    public clearDetailState() {
        this.itemToEdit= undefined, 
        this.itemToDel= undefined, 
        this.newItem=false
    }

    /**
     * clearJumpState
     */
    public clearJumpState() {
        this.itemToJump= undefined
    }

    /**
     * cloneSelf
     */
    public cloneSelf() : EsaedroHistoryItem {

        let objToRet = new EsaedroHistoryItem ({})

        objToRet.selectedItem = Object.assign({},this.selectedItem)
        objToRet.itemToEdit=Object.assign({},this.itemToEdit)
        objToRet.itemToDel=Object.assign({},this.itemToDel)
        objToRet.itemToJump=Object.assign({},this.itemToJump)
        objToRet.newItem=this.newItem
        objToRet.startingPage=this.startingPage
        objToRet.customComponentName=this.customComponentName
        
        if (this.menuItems.length) {
            let newMenuItems: any[] = []
            this.menuItems.forEach(element => {
                newMenuItems.push(Object.assign({},element))
            });
            objToRet.menuItems=newMenuItems
        }
        if (this.jumpMenuItems.length) {
            let newJumpMenuItems: any[] = []
            this.jumpMenuItems.forEach(element => {
                newJumpMenuItems.push(Object.assign({},element))
            });
            objToRet.jumpMenuItems=newJumpMenuItems
        }

        if (this.selectedItemFilters.length) {
            let newSelectedItemFilters: EsaedroResourceFilter[] = []
            this.selectedItemFilters.forEach(element => {
                newSelectedItemFilters.push(new EsaedroResourceFilter(element.FieldName, element.Value, element.Operator, element.description))
            });
            objToRet.selectedItemFilters=newSelectedItemFilters
        }

        if (this.listInputFilters.length) {
            let newListInputFilters: EsaedroResourceFilter[] = []
            this.listInputFilters.forEach(element => {
                newListInputFilters.push(new EsaedroResourceFilter(element.FieldName, element.Value, element.Operator, element.description))
            });
            objToRet.listInputFilters=newListInputFilters
        }

        return objToRet
    }

    constructor(selectedItem: any, 
                itemToEdit?: any, 
                itemToDel?: any, 
                itemToJump?: any, 
                newItem?: boolean, 
                menuItems?: any[], 
                jumpMenuItems?: any[], 
                selectedItemFilters?: EsaedroResourceFilter[], 
                listInputFilters?: EsaedroResourceFilter[], 
                startingPage?: number,
                customComponentName?: string
                ) {

        this.selectedItem=selectedItem
        this.itemToEdit=itemToEdit
        this.itemToDel=itemToDel
        this.itemToJump=itemToJump
        this.newItem=newItem?newItem:false
        this.menuItems=menuItems?menuItems:[]
        this.jumpMenuItems=jumpMenuItems?jumpMenuItems:[]
        this.selectedItemFilters=selectedItemFilters?selectedItemFilters:[]
        this.listInputFilters=listInputFilters?listInputFilters:[]
        this.startingPage=startingPage?startingPage:1
        this.customComponentName=customComponentName?customComponentName:''
    }

}

export default EsaedroHistoryItem;